/* eslint-disable react/no-multi-comp */
import classnames from 'classnames';
import { CreateEditJobNavEnum } from 'containers/jobs/constant';
import { FC, useContext } from 'react';
import { twMerge } from 'tailwind-merge';
import { VoidFn } from 'types/baseTypes';

interface JobSectionTabProps {
  title: string;
  isSelected: boolean;
  onClick: VoidFn;
  id: string;
}

const JobSectionTab: FC<JobSectionTabProps> = ({ title, isSelected, onClick, id }) => {
  return (
    <div
      id={id}
      onClick={onClick}
      className={twMerge(
        'cursor-pointer rounded h-50 py-[15px] 1439px:py-4 pl-6 font-semibold text-[#3E556D]',
        classnames({ 'text-secondary ring-1 ring-secondary': isSelected })
      )}>
      <div className="text-17px">{title}</div>
    </div>
  );
};
interface CreateEditJobNavProps {
  context: React.Context<any>;
}

const CreateEditJobNav: FC<CreateEditJobNavProps> = ({ context }) => {
  const { selectedJobTab, setSelectedJobTab } = useContext<any>(context);

  const isselectedInvoiceTab = (tab: CreateEditJobNavEnum) => {
    return tab === selectedJobTab;
  };

  return (
    <div className="flex w-full flex-col 1439px:space-y-5">
      <JobSectionTab
        id="create-invoice-side-nav-bill-to"
        title={CreateEditJobNavEnum.JOB_FOR}
        isSelected={isselectedInvoiceTab(CreateEditJobNavEnum.JOB_FOR)}
        onClick={() => setSelectedJobTab(CreateEditJobNavEnum.JOB_FOR)}
      />
      <JobSectionTab
        id="create-invoice-side-nav-invoice-options"
        title={CreateEditJobNavEnum.JOB_DETAILS}
        isSelected={
          isselectedInvoiceTab(CreateEditJobNavEnum.JOB_DETAILS) ||
          isselectedInvoiceTab(CreateEditJobNavEnum.JOB_SCHEDULE)
        }
        onClick={() => setSelectedJobTab(CreateEditJobNavEnum.JOB_DETAILS)}
      />
      <JobSectionTab
        id="create-invoice-side-nav-line-items"
        title={CreateEditJobNavEnum.LINE_ITEMS}
        isSelected={isselectedInvoiceTab(CreateEditJobNavEnum.LINE_ITEMS)}
        onClick={() => setSelectedJobTab(CreateEditJobNavEnum.LINE_ITEMS)}
      />
      <JobSectionTab
        id="create-invoice-side-nav-notes-and-attachments"
        title={CreateEditJobNavEnum.NOTES_ATTACHMENTS}
        isSelected={isselectedInvoiceTab(CreateEditJobNavEnum.NOTES_ATTACHMENTS)}
        onClick={() => setSelectedJobTab(CreateEditJobNavEnum.NOTES_ATTACHMENTS)}
      />
      <JobSectionTab
        id="create-invoice-side-nav-payment-options"
        title={CreateEditJobNavEnum.MORE_OPTIONS}
        isSelected={isselectedInvoiceTab(CreateEditJobNavEnum.MORE_OPTIONS)}
        onClick={() => setSelectedJobTab(CreateEditJobNavEnum.MORE_OPTIONS)}
      />
    </div>
  );
};

export default CreateEditJobNav;
